import React from "react";
import { FaTwitch } from "react-icons/fa";
const PageTwitchChannel = ({ link, themeFontColor }) => {
  return (
    <div className="link-spotify link-el">
      <h2 style={{ color: themeFontColor }}>
        <FaTwitch className="icon-page-heading" />
        {link.LinkTitle}
      </h2>{" "}
      <div
        className="spotify-iframe"
        dangerouslySetInnerHTML={{
          __html: `<iframe
        src="https://player.twitch.tv/?channel=${link.LinkUrl}&parent=${
            process.env.NODE_ENV === "development"
              ? "localhost"
              : "app.linksight.me"
          }&muted=true"
        height="auto"
        width="auto"
        frameborder="0"
        scrolling="no"
        allowfullscreen="true">
    </iframe>`,
        }}
      />
    </div>
  );
};

export default PageTwitchChannel;
